<template>
  <div
    v-if="report"
    class="col-9 b-report-container"
  >
    <div class="b-report-header">
      <div class="row b-label">
        <div class="col-6">Отчет</div>
        <div
          class="col-6 b-report-export-btn"
          style="text-align: right; cursor: pointer;"
          v-loading.fullscreen.lock="loading"
          @click="exportReport"
        >
          Экспортировать все данные
        </div>
      </div>
      <hr class="my-0">
    </div>
    <div class="container">
      <div class="b-report-content">
        <div v-for="sentence in report.data?.content">
          <div
            class="b-report-title"
            v-if="report.data.objects[0]"
          >
            {{ sentence }}
          </div>
          <div
            v-else
          >
            {{ sentence }}
          </div>
        </div>
      </div>
      <div class="b-report-objects-content">
        <div v-for="object in report.data?.objects">
          <div class="b-report-object">Объект {{ object.name }}</div>
          <div
            v-if="object.content.length > 0"
            v-for="sentence in object.content"
          >
            {{ sentence }}
          </div>
          <div v-else>Информация по объекту отсутствует</div>
          <hr class="my-2">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { saveAs } from 'file-saver';
export default {
  name: "ReportMain",
  props: {
    report: {
      type: Object,
      required: true,
    },
    reportData: {
      type: Object,
      required: true,
    },
    objects: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    exportReport() {
      this.loading = true;
      axios.post(route('reports.export', this.reportData.place), this.reportData, {
        responseType: 'blob',
      }).then(response => {
        saveAs(
          response.data,
          this.reportData.report + '_'
          + this.reportData.place + '_'
          + this.reportData.date_from + '.docx'
        );
      }).catch(error => {
        console.log(this.reportData)
        this.$notify.error({
          title: 'Ошибка',
          message: 'Не удалось экспортировать отчет',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
  },
}
</script>

<style scoped>
.b-report-container {
  background-color: white;
  margin: 15px 0;
  padding: 25px;
  border: 1px solid #ebebeb;
  border-radius: 3px;
}

.b-report-export-btn {
  color: #259853;
  text-decoration: underline;
}

.b-report-title {
  font-size: 18px;
  margin-bottom: 5px;
}

.b-report-content {
  margin-top: 15px;
}

.b-label {
  margin-bottom: 10px;
}

.b-report-object {
  font-size: 22px;
  font-weight: bold;
  margin: 15px 0;
}

</style>
